import { render, staticRenderFns } from "./ToDoCardSkeleton.vue?vue&type=template&id=29660ccb"
import script from "./ToDoCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ToDoCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports